import PropTypes from 'prop-types';

import ModalTrigger from './Modals/ModalTrigger';
import { BiHelpCircle, BiInfoCircle, BiBarChartAlt2 } from 'react-icons/bi';
import { BsTools } from 'react-icons/bs';

import { GAME_TITLE } from '../constants/strings';

import style from '../styles/Header.module.scss';

const Header = ({ howToPlayModalRef, devModalRef, aboutModalRef, statsModalRef }) => {
  return (
    <header className={style.header}>
      <div className={style.content}>
        <div className={style['buttons-wrapper']}>
          <ModalTrigger 
            modalRef={howToPlayModalRef}
            modalTitle="instructions">
            <BiHelpCircle/>
          </ModalTrigger>
          <ModalTrigger
            classes={style['dev-modal-trigger']}
            modalRef={devModalRef}
            modalTitle="dev">
            <BsTools/>
          </ModalTrigger>
          <ModalTrigger
            classes={style['about-modal-trigger']}
            modalRef={aboutModalRef}
            modalTitle="about">
            <BiInfoCircle/>
          </ModalTrigger>
        </div>
        <h1>
          {GAME_TITLE}
        </h1>
        <div className={style['buttons-wrapper']}>
          <ModalTrigger 
            modalRef={statsModalRef}
            modalTitle="stats">
            <BiBarChartAlt2/>
          </ModalTrigger>
        </div>
      </div>
      
    </header>
  );
};

Header.propTypes = {
  howToPlayModalRef: PropTypes.object.isRequired,
  devModalRef: PropTypes.object.isRequired,
  aboutModalRef: PropTypes.object.isRequired,
  statsModalRef: PropTypes.object.isRequired
};

export default Header;